const mapStateToProps = (state) => {
    const {
        api:{
            // singleDocument,
            addingDocument,
            savingDocument,
        }={},
        user:{
            rights,
        }={},

        service:{
            Api:{
                // getSingleDocument,
                addDocument,
                saveDocument,
                getPlanWorkDir,
                // actions:{
                //     setSingleDocument,
                // }={},
            }={}
        }={}
    } = state;
    return {
        // singleDocument,
        addingDocument,
        savingDocument,
        rights,
        // getSingleDocument,
        addDocument,
        saveDocument,
        getPlanWorkDir,
        // setSingleDocument,
      }
}

export default mapStateToProps;